import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DeleteFieldImageDTO, FieldsApiService } from 'features/fields';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { fieldsQueryKeys } from './query-keys';

const { deleteFieldGalleryImage } = FieldsApiService();

export const useDeleteFieldGalleryImage = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: DeleteFieldImageDTO) => {
      return deleteFieldGalleryImage(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        console.error(uiMessage);
        message.error(i18n.t('fields.update.errorCoverImageDelete'));
      },
      onSuccess: (_, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.detail(variables.id),
          }),
        ]);
        message.success(i18n.t('fields.update.successfulCoverImageDelete'));
      },
    },
  );
};
